import React, { createContext, useContext } from "react";
import type { BillingAccessState } from "./BillingRecoveryModal";

type BillingAccessContextValue = {
  state: BillingAccessState | null;
  openPaymentRecovery: () => void;
  completePaymentRecovery: (state: BillingAccessState) => void;
};

const BillingAccessContext = createContext<BillingAccessContextValue>({
  state: null,
  openPaymentRecovery: () => undefined,
  completePaymentRecovery: () => undefined,
});

export const BillingAccessProvider = BillingAccessContext.Provider;

export function useBillingAccess() {
  return useContext(BillingAccessContext);
}
